import { render } from "./UiRadioGroup.vue?vue&type=template&id=959dd784&ts=true"
import script from "./UiRadioGroup.vue?vue&type=script&lang=ts"
export * from "./UiRadioGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__